var Coverage;
(function (Coverage) {
    Coverage["Local"] = "local";
    Coverage["Global"] = "global";
})(Coverage || (Coverage = {}));

export { Coverage };
